import { createContext, useContext } from 'react';
import { useGeolocation } from '../hooks/useGeolocation.js';

interface GeolocationContextValue {
  latitude: number | null;
  longitude: number | null;
  accuracy: number | null;
  error: GeolocationPositionError | null;
  loading: boolean;
  refresh: () => void;
}

const GeolocationContext = createContext<GeolocationContextValue>({
  latitude: null,
  longitude: null,
  accuracy: null,
  error: null,
  loading: true,
  refresh: () => {},
});

export function GeolocationProvider({ children }: { children: React.ReactNode }) {
  const geo = useGeolocation();
  return <GeolocationContext.Provider value={geo}>{children}</GeolocationContext.Provider>;
}

export function useGeolocationContext() {
  return useContext(GeolocationContext);
}
